const o = {
  viewBtn: {
    icon: 'el-icon-view',
    class: 'viewbtn',
    title: '查看',
  },
  editBtn: {
    icon: 'el-icon-edit-outline',
    class: 'editbtn',
    title: '编辑',
  },
  delBtn: {
    icon: 'el-icon-delete',
    class: 'delbtn',
    title: '删除',
  },
  feeBtn: {
    class: 'feebtn',
    title: '费用登记',
    img: require('@/assets/img/icon_operate_05.png'),
    unimg: require('@/assets/img/icon_operate_05_hover.png'),
  },
}

export default o